import React, { FunctionComponent, ReactNode } from "react";

type LabelProps = {
  children: ReactNode;
  htmlFor: string;
};

export const Label: FunctionComponent<LabelProps> = ({ children, htmlFor }) => {
  return (
    <label
      className="text-xs text-ink-2 ml-4 -mb-4 block pointer-events-none md:translate-y-1 opacity-60"
      htmlFor={htmlFor}
    >
      {children}:
    </label>
  );
};
